<template>
  <b-modal
    :id="modalId"
    centered
    title="Attendance"
    @hide="$emit('close')"
    hide-header-close
    @hidden="onHidden"
    size="lg"
    hide-footer
  >
    <div class="p-2 d-flex flex-column gap-4">
      <b-row class="d-flex flex-column rounded bg-dark-soft p-4 gap-3">
        <b-row class="d-flex flex-row justify-content-between align-items-center">
          <b-col class="d-flex flex-column gap-1 col-4">
            <label>Training Title</label>
            <h4>{{ data?.training?.title }}</h4>
          </b-col>

          <b-col class="d-flex flex-column gap-1 col-4">
            <label>Batch</label>
            <h4>{{ formatBatchLabel(data) }}</h4>
          </b-col>

          <b-col class="d-flex flex-column gap-1 col-4">
            <label>Status</label>
            <span :class="getTrainingStatusClass(data?.status)" class="mr-auto">
              {{ snakeToTitle(data?.status) }}
            </span>
          </b-col>
        </b-row>

        <b-row class="d-flex flex-row justify-content-start align-items-center">
          <b-col class="d-flex flex-column gap-1 col-4">
            <label>Quota</label>
            <h4>{{ data?.quota }} people</h4>
          </b-col>

          <b-col class="d-flex flex-column gap-1 col-4">
            <label>Location</label>
            <h4>{{ data?.location }}</h4>
          </b-col>
        </b-row>
      </b-row>

      <b-form ref="form">
        <b-form-group label="Schedules">
          <vue-good-table
            :columns="schedulesColumns"
            :rows="data?.schedules"
            style-class="vgt-table border-0 table-auto"
            styleClass="vgt-table condensed"
          >
            <div slot="emptystate" class="text-center font-size-14">No data available</div>

            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'action'" class="d-flex gap-3 justify-content-center align-items-center">
                <b-button
                  v-if="props.row.attendance_id"
                  class="no-wrap btn-pill"
                  variant="info"
                  size="sm"
                  title="View attendance"
                  @click="$emit('view-attendance', { id: props.row.attendance_id })"
                >
                  <span class="fe fe-eye"></span>
                </b-button>
                <b-button
                  v-else-if="props.row?.is_allow_submission"
                  class="no-wrap btn-pill"
                  variant="info"
                  size="sm"
                  title="Submit attendance"
                  @click="$emit('open-submit-attendance-modal', props.row)"
                >
                  <span class="fe fe-user-check" aria-hidden="true"></span>
                </b-button>
              </span>

              <span v-else-if="props.column.field === 'date'">
                <div class="d-flex flex-row align-items-center justify-content-start">
                  <span>{{ formatDate(props.row.date) }}</span>
                </div>
              </span>

              <span v-else-if="props.column.field === 'start_time'">
                <div class="d-flex flex-row align-items-center justify-content-start">
                  <span>{{ formatTimeToHHMM(props.row.start_time) }}</span>
                </div>
              </span>

              <span v-else-if="props.column.field === 'participant'">
                <div class="d-flex flex-row align-items-center justify-content-start">
                  <span>{{ props.row.participant }} people</span>
                </div>
              </span>

              <span v-else-if="props.column.field === 'end_time'">
                <div class="d-flex flex-row align-items-center justify-content-start">
                  <span>{{ formatTimeToHHMM(props.row.end_time) }}</span>
                </div>
              </span>

              <span v-else-if="props.column.field === 'status'">
                <div class="d-flex flex-row align-items-center justify-content-start">
                  <span :class="getTrainingStatusClass(props.row.status)">
                    {{ snakeToTitle(props.row.status) }}
                  </span>
                </div>
              </span>

              <span v-else class="d-flex align-items-center justify-content-start">
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </b-form-group>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import { formatDate, formatTimeToHHMM, getTrainingStatusClass, snakeToTitle, cleanObject } from "../utils/utils";
import { formatBatchLabel } from "@/utils/batchIdentity";

export default {
  name: "EventModal",

  props: {
    modalId: { type: String, default: "event-modal" },
    data: { type: Object, default: null },
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      suppressValidation: false,
      schedulesColumns: [
        {
          label: "Date",
          field: "date",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Start Time",
          field: "start_time",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "End Time",
          field: "end_time",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary",
        },
        {
          label: "Participant",
          field: "participant",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold w-action",
          tdClass: "color-secondary text-center",
        },
        {
          label: "Status",
          field: "status",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold w-action",
          tdClass: "color-secondary text-center",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          thClass: "table-header text-muted font-weight-bold w-action",
          tdClass: "color-secondary text-center",
        },
      ],
    };
  },

  methods: {
    formatTimeToHHMM,
    formatDate,
    getTrainingStatusClass,
    snakeToTitle,
    formatBatchLabel,

    onHidden() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
:deep(.table-header) {
  font-size: 11px !important;
}

:deep(.vgt-left-align) {
  align-content: center !important;
}

:deep(.vgt-table td, .vgt-table th) {
  font-size: 11px !important;
}
</style>
